'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$185() {
  this.cfz = null;
  this.cfx = null;
  this.cfy = false;
  this.cfv = null;
  this.cfw = false;
  this.cfA = false;
  this.cfB = false;
  this.cfz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$$anon$185 as $c_Lpresto_types$proto$$anon$185 };
$p = $c_Lpresto_types$proto$$anon$185.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$185;
/** @constructor */
function $h_Lpresto_types$proto$$anon$185() {
}
export { $h_Lpresto_types$proto$$anon$185 as $h_Lpresto_types$proto$$anon$185 };
$h_Lpresto_types$proto$$anon$185.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.cfz;
});
$p.t = (function() {
  if ((!this.cfy)) {
    this.cfx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cfy = true;
  }
  return this.cfx;
});
$p.ag = (function() {
  if ((!this.cfw)) {
    this.cfv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().a37(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cfw = true;
  }
  return this.cfv;
});
$p.v = (function() {
  if ((!this.cfB)) {
    this.cfA = false;
    this.cfB = true;
  }
  return this.cfA;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$$anon$185 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$185, "presto.types$proto$$anon$185", ({
  a33: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$$anon$185 as $d_Lpresto_types$proto$$anon$185 };
//# sourceMappingURL=presto.types$proto$$anon$185.js.map
